import { useState } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import AuthInfoObj from "../../ApiServices/AuthInfoObj";
import { APPID, DOMAIN_NAME, VERSION } from "../../Config.js";

export const ProfileService = () => {
  const [profileReportData, setProfileReportData] = useState();
  const [targetAchieveData, setTargetAchieveData] = useState([]);
  const [targetAchievePopup, setTargetAchievePopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [balanceData, setBalanceData] = useState();

  const getBalanceUser = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetBalance",
        data: {},
        headers: {
          appID: APPID,
          version: VERSION,
          domain: DOMAIN_NAME,
          userID: AuthInfoObj().userID,
          sessionID: AuthInfoObj().sessionID,
          session: AuthInfoObj().session,
        },
      });

      if (res?.statuscode === 1) {
        setBalanceData(res?.data);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getBalanceUser :", error);
    }
  };

  const getProfileReport = async () => {
    try {
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetProfile",
        data: null,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });

      if (res?.statuscode === 1) {
        setProfileReportData(res);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getProfileReport :", error);
    }
  };

  const getTagetAchievement = async () => {
    try {
      setLoading(true);
      const res = await ApiCalling.apiClient.request({
        method: "POST",
        url: "/GetB2cTargetAchieved",
        data: null,
        headers: {
          session: sessionStorage.getItem("session"),
          sessionID: sessionStorage.getItem("sessionID"),
          userID: sessionStorage.getItem("userID"),
        },
      });
      if (res?.statuscode === 1) {
        setTargetAchievePopup(true);
        setTargetAchieveData(res?.b2cTargetAchieved);
      } else {
        console.error(res?.msg);
      }
    } catch (error) {
      console.error("Error getTagetAchievement :", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    getProfileReport,
    profileReportData,
    getTagetAchievement,
    targetAchieveData,
    targetAchievePopup,
    setTargetAchievePopup,
    balanceData,
    getBalanceUser,
  };
};
